/**
 * Fotos de câmera por área Guardian.
 * GET  /guardian/areas/:id/cameras/
 * POST /guardian/areas/:id/cameras/          campo photo
 * POST /guardian/areas/:id/cameras/archive/  campo archive (.zip ou .rar)
 */
import api from "./api";

const base = (areaId) => `/guardian/areas/${areaId}/cameras/`;

function asList(raw) {
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.results)) return raw.results;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
}

export const areaCamerasService = {
  list: async (areaId, { limit } = {}) => {
    const response = await api.get(base(areaId), {
      params: limit ? { limit } : undefined,
    });
    return asList(response.data);
  },

  uploadPhoto: async (areaId, file) => {
    const form = new FormData();
    form.append("photo", file);
    const response = await api.post(base(areaId), form);
    return response.data;
  },

  uploadArchive: async (areaId, file) => {
    const form = new FormData();
    form.append("archive", file);
    const response = await api.post(`${base(areaId)}archive/`, form);
    return response.data;
  },
};

export default areaCamerasService;
